import {
    ALTITUDE_METRIC_MAX,
    ALTITUDE_METRIC_MIN,
    ROUTE_SPACING_METRIC_MAX,
    ROUTE_SPACING_METRIC_MIN
} from '../../constants';
import { feetToMeters } from 'utils/distanceUtil';

import type { UseImperialHandlersParams, UseImperialHandlersReturn } from './types';

const clamp = (meters: number, min: number, max: number) => Math.max(min, Math.min(meters, max));

const useImperialHandlers = ({
    onUpdate
}: UseImperialHandlersParams): UseImperialHandlersReturn => {
    const handleRouteSpacingChange: UseImperialHandlersReturn['handleRouteSpacingChange'] = ({
        value
    }) =>
        onUpdate({
            routeSpacing: clamp(
                feetToMeters(value),
                ROUTE_SPACING_METRIC_MIN,
                ROUTE_SPACING_METRIC_MAX
            )
        });

    const handleAltitudeChange: UseImperialHandlersReturn['handleAltitudeChange'] = ({ value }) =>
        onUpdate({
            altitudeAgl: clamp(feetToMeters(value), ALTITUDE_METRIC_MIN, ALTITUDE_METRIC_MAX)
        });

    return { handleAltitudeChange, handleRouteSpacingChange };
};

export default useImperialHandlers;
